import { render, staticRenderFns } from "./ContractParties.vue?vue&type=template&id=1479a208&scoped=true&"
import script from "./ContractParties.vue?vue&type=script&lang=js&"
export * from "./ContractParties.vue?vue&type=script&lang=js&"
import style0 from "./ContractParties.vue?vue&type=style&index=0&id=1479a208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479a208",
  null
  
)

export default component.exports